import React, { useEffect, useRef, useState } from 'react'
import "../../Styles/Contact.scss"
import ContactUs from "../../Assests/ContactUs/ContactUsBGImg.png"
import IN from "../../Assests/ContactUs/in.svg"
import X from "../../Assests/ContactUs/X.svg"
import IG from "../../Assests/ContactUs/Ig.svg"
// import FB from "../../Assests/ContactUs/FB.svg"
import plus from '../../Assests/ContactUs/plus.svg'
import cancel from '../../Assests/ContactUs/cancel.svg'
import { toast } from 'react-toastify';

import { useLocation } from 'react-router-dom'
function Contact() {

  const [openIndex, setOpenIndex] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    subject: '',
    // message: '',
  });



  const location = useLocation();
  const whoWeAreRef = useRef(null);

  useEffect(() => {
    // Check if hash or state indicates scrolling to FAQ
    if (location.hash === "#faq" || location.state?.scrollToFAQ) {
      whoWeAreRef.current?.scrollIntoView({ behavior: "smooth" });
      whoWeAreRef.current?.focus();
    }
  }, [location]);
  

  const questionsAndAnswers = [
    {
      question: "How does Vizzhy ensure my data privacy?",
      answer:
        "We use industry-leading encryption and blockchain technologies to ensure that your health data is completely secure and private.",
    },
    {
      question: "What is the role of IoT devices in my health management?",
      answer:
        "Our IoT devices continuously monitor your vitals and other key health metrics providing real-time data that allows for timely interventions and adjustments to your treatment plan.",
    },
    {
      question: "Do I need to visit a clinic for sample collection?",
      answer:
        "No, Vizzhy offers convenient at-home sample collection kits with full instructions provided that can be easily used.",
    },
    {
      question: "How often will I receive updates on my health data?",
      answer:
        "With our continuous monitoring system, you will have access to real-time updates through our app with regular summaries provided by your health advisor.",
    },
    {
      question: "What kind of data is included in Multi-Omics Analysis?",
      answer:
        "Multi-Omics Analysis at Vizzhy includes genomics, transcriptomics, proteomics, gut microbiome, oral microbiome, metabolomics, and lipidomics to offer a comprehensive understanding of a person’s metabolic health.",
    },
  ];

  const restrictEmojis = (value) => {
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{23F0}\u{231A}]/gu;
    return value.replace(emojiRegex, '');
  };



  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const blockNumSpec = (value) => {
  
    value = value.replace(/[0-9]/g, '');

    value = value.replace(/[^a-zA-Z\s\-]/g, '');

    return value;
};

const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === 'firstName' || name === 'lastName') {
        updatedValue = blockNumSpec(value);
    }
    const sanitizedValue = restrictEmojis(updatedValue);

    setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
    }));

    setFormData({ ...formData, [name]: sanitizedValue });
};


  const handleSubjectChange = (e) => {
    const { value } = e.target;

    const sanitizedValue = restrictEmojis(value);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      subject: '',
    }));

    setFormData((prevData) => ({
      ...prevData,
      subject: sanitizedValue,
    }));
  };





  const validateForm = () => {
    let errors = {};
    let isValid = true;

    Object.keys(formData).forEach((field) => {
      if (field !== 'message' && !formData[field]) {
        errors[field] = `${field} is required`;
        isValid = false;
      }
    });

    if (formData.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const apiUrl = `${process.env.vizzhy_website_api_url}/homePage/contactUs?requestId=123`;
    const apiKey = process.env.REACT_APP_API_KEY_VIZZHYWEB;

    const payload = {
      checksum: "string",
      data: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailId: formData.email,
        subject: formData.subject,
        message: formData.message || " ",
        phoneNumber: formData.phoneNumber,
      },
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success('Message sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          subject: '',
          message: '',
        });
      } else {
        if (result.errors && result.errors.length > 0) {
          result.errors.forEach((error) => {
            toast.error(error);
          });
        }
      }
    } catch (err) {
      toast.error('An error occurred while sending the message. Please try again later.', { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setLoading(false);
    }
  };





  return (
    <div className='contact '>
      <div className='dna-bg mt-5 p-5'>
        <div className='container mt-5 dna-container'>
          <div className='card contact-maincard'>
            <div className='contact-main-row row w-100 p-3'>
              <div className='col-md'>
                <div class="contact-container">
                  <img src={ContactUs} alt="Snow" style={{ width: "100%" }} />
                  <div class="contact-bottom-left w-50">
                    <div>
                      <div className='d-flex w-100 justify-content-evenly'>
                        <div>
                          <a href="https://www.linkedin.com/company/vizzhy/" target="_blank" rel="noopener noreferrer">
                          <img src={IN} className='social-media-img' alt='IN'/>
                          </a>
                        </div>
                        <div>
                          <a href="https://x.com/vizzhy_health?lang=en" target="_blank" rel="noopener noreferrer">
                          <img src={X} className='social-media-img' alt='X'/></a>
                        </div>
                        <div>
                        <a href="https://www.instagram.com/vizzhy_healthcare/" target="_blank" rel="noopener noreferrer">
                        <img src={IG} className='social-media-img' alt='IG'/>
                        </a>
                        </div>
                        {/* <div><img src={FB} className='social-media-img'/></div> */}

                      </div>
                    </div>
                  </div>

                  <div className="contact-centered p-4 w-100">
                    <div className=' d-flex text-start pt-5'>
                      <div >
                        <div className='fw-bold fs-3 get-in-touch'>Get in touch with Us.</div>
                        <div className='fs-5 we-will-get-back' style={{ color: "#C9C9C9" }}>We will get back to you in less than 24 hours :)</div>
                      </div>
                    </div>





                  </div>
                  <div className="contact-centered-2 p-4 w-100">
                    <div className='email-address' >
                      <div className='mt-5'>
                        <div className='row w-75 text-start email-address-content'>
                          <div className='col-2 col-md-2'>
                            <span class="material-symbols-outlined">
                              mail
                            </span>
                          </div>
                          <div className='col-10 col-md-10'>
                            <a href='mailto:info@vizzhy.com' style={{ textDecoration: "none", color: "white" }}>info@vizzhy.com</a>
                          </div>
                          <div></div>
                        </div>
                      </div>

                      <div className='mt-4'>
                        <div className='row w-75 text-start email-address-content'>
                          <div className='col-2 col-md-2 '>
                            <span class="material-symbols-outlined">
                              pin_drop
                            </span>
                          </div>
                          <div className='col-10 col-md-10'>
                            <div>
                            #133, 2nd floor, Raheja Chancery,
                             Brigade Rd, Shanthala Nagar, Richmond Town, Bengaluru, Karnataka 560025.
                            </div>
                            <div className='mt-3'>
                              651 N.Broad ST. STE. 201 Middletown, DE 19709 ,USA
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>




                </div>
              </div>
              <div className='col-md'>

                <div className='contact-info p-3'>
                  {/* <form onSubmit={handleSubmit}> */}
                  <div className='row w-100  mt-4'>
                    <div className='col-md-6'>
                      <div className='first-name'>
                      <div className=' mt-2 missionandvisiontextcolor '>First Name <span className='red-star'>*</span></div>
                      <div className="input-group mt-1">
                        <input
                          type="text"
                          name="firstName"
                          onChange={handleInputChange}
                          value={formData.firstName}
                          className="no-border"
                          placeholder="Enter first name"
                          autoComplete="off"
                        />

                      </div>
                      {formErrors.firstName && <div className="text-danger">{formErrors.firstName}</div>}
                      </div>
                      
                    </div>
                    <div className='col-md-6'>
                      <div className='last-name'>
                      <div className=' mt-2 missionandvisiontextcolor'>Last Name <span className='red-star'>*</span></div>
                      <div className="input-group mt-1">
                        <input
                          type="text"
                          name="lastName"
                          onChange={handleInputChange}
                          value={formData.lastName}
                          className="no-border"
                          placeholder="Enter last name"
                          autoComplete="off"
                        />

                      </div>
                      {formErrors.lastName && <div className="text-danger">{formErrors.lastName}</div>}
                      </div>
                      
                    </div>
                  </div>

                  <div className='row w-100  mt-5 email-phone-no'>
                    <div className='col-md-6'>
                      <div className='email-id'>
                      <div className=' mt-2 missionandvisiontextcolor'>Email <span className='red-star'>*</span></div>
                      <div className="input-group mt-1">
                        <input
                          type="text"
                          onChange={handleInputChange}
                          name="email"
                          value={formData.email}
                          className="no-border"
                          placeholder="Enter your email address"
                          autoComplete="off"
                        />

                      </div>
                      {formErrors.email && <div className="text-danger">{formErrors.email}</div>}
                      </div>
                      
                    </div>
                    <div className='col-md-6'>
                      <div className='Phone-Number'>
                      <div className=' mt-2 missionandvisiontextcolor'>Phone Number <span className='red-star'>*</span></div>
                      <div className="input-group mt-1">
                        <input
                          type="text"
                          name="phoneNumber"
                          onChange={handleInputChange}
                          value={formData.phoneNumber}
                          className="no-border"
                          placeholder="Enter your phone number"
                          autoComplete="off"
                          maxLength="15"
                          onInput={(e) => {
                            let input = e.target.value;

                            if (input.startsWith('+')) {
                              input = '+' + input.slice(1).replace(/[^0-9]/g, '').slice(0, 15);
                            } else {
                              input = input.replace(/[^0-9]/g, '').slice(0, 15);
                            }

                            e.target.value = input;
                            handleInputChange(e);
                          }}
                        />

                      </div>
                      {formErrors.phoneNumber && <div className="text-danger">{formErrors.phoneNumber}</div>}
                      </div>
                    </div>
                  </div>

                  <div className='row w-100 mt-5 subject-selection'>
                    <div className='fs-5 question-text'>Select Subject? <span className='red-star'>*</span></div>


                    <div className='col-6 col-md-4'>
                      <div className="subject-option mt-1">
                        <input
                          type="radio"
                          id="general-inquiry"
                          name="subject"
                          value="General Inquiry"
                          checked={formData.subject === "General Inquiry"}
                          onChange={handleSubjectChange}
                          className="subject-radio"
                        />
                        <label htmlFor="general-inquiry" className="custom-radio"></label>
                        <div className='label-text mt-1 ms-2'>General Inquiry</div>
                      </div>
                    </div>

                    <div className='col-6 col-md'>
                      <div className="subject-option mt-1">
                        <input
                          type="radio"
                          id="complaint"
                          name="subject"
                          value="Complaint"
                          checked={formData.subject === "Complaint"}
                          onChange={handleSubjectChange}
                          className="subject-radio"
                        />
                        <label htmlFor="complaint" className="custom-radio"></label>
                        <div className='label-text mt-1 ms-2'>Complaint</div>
                      </div>
                    </div>

                    <div className='col-6 col-md'>
                      <div className="subject-option mt-1">
                        <input
                          type="radio"
                          id="feedback"
                          name="subject"
                          value="Feedback"
                          checked={formData.subject === "Feedback"}
                          onChange={handleSubjectChange}
                          className="subject-radio"
                        />
                        <label htmlFor="feedback" className="custom-radio"></label>
                        <div className='label-text mt-1 ms-2'>Feedback</div>
                      </div>
                    </div>

                    <div className='col-6 col-md'>
                      <div className="subject-option mt-1">
                        <input
                          type="radio"
                          id="other"
                          name="subject"
                          value="Other"
                          checked={formData.subject === "Other"}
                          onChange={handleSubjectChange}
                          className="subject-radio"
                        />
                        <label htmlFor="other" className="custom-radio"></label>
                        <div className='label-text mt-1 ms-2'>Other</div>
                      </div>
                    </div>
                  </div>
                  {formErrors.subject && <div className="text-danger">{formErrors.subject}</div>}


                  <div className='row w-100 mt-5 leave-message'>
                    {/* <div className=' mt-2 '>Message <span className='red-star'>*</span></div> */}
                    <div className=' mt-2 '>Message</div>

                    <div className="input-group mt-3  w-100">
                      <input
                        type="text"
                        name="message"
                        onChange={handleInputChange}
                        value={formData.message}
                        className="message-area no-border"
                        placeholder="Write your message.."
                        autoComplete="off"
                      />
                      {/* <textarea className='message-area no-border' placeholder="Write your message.."></textarea> */}
                    </div>
                    {/* {formErrors.message && <div className="text-danger">{formErrors.message}
                    </div>} */}

                  </div>

                  <div className='d-flex mt-5 pt-3 justify-content-end send-message'>
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className='d-flex justify-content-center primary-btn py-3 px-5 contactus-contact-us mt-3 fw-bold contact-us'
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>

                  {/* </form> */}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div className=' who-we-are-bg ' ref={whoWeAreRef}
        tabIndex={-1}>
        <div className='p-5 faq'>
          <div className='container mt-4 faq-container'>
            <div className='fs-1 w-100 fw-bold missionandvisiontextcolor faq-heading'>FAQ</div>
            <div className="accordion mt-5 mobile-accordion" id="accordionExample">
              {questionsAndAnswers.map((item, index) => (
                <div className="accordion-item " key={index}>
                  <div>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}
                        aria-expanded={openIndex === index}
                        aria-controls={`collapse${index}`}
                        onClick={() => toggleAccordion(index)}
                      >
                        <span>
                          <img
                            src={openIndex === index ? cancel : plus}
                            alt="toggle-icon"
                            // className='plus-cancel-image'
                          />
                        </span>{" "}<span className='ms-4 fs-4 faq-question'>{item.question}</span>

                      </button>
                    </h2>
                  </div>

                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${openIndex === index ? "show" : ""
                      }`}
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body p-4 ms-5 ps-4">
                      <div className='answer-bg fs-5 p-3 rounded-4 shadow-sm faq-answer'>{item.answer}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

    </div>
  )
}

export default Contact